module.exports = __webpack_public_path__ + "Fedex-logo.png";